module.exports = __webpack_public_path__ + "static/media/11NEPAD5.5acf75e8.jpg";